import React from "react";

import { PlansPanel } from "../../components/plan/index.js";

export default () => <PlansPanel type="sm" isPaper={false} />;
